import WithImages from './WithImagesTemplate';

export default WithImages;
